module.exports = __webpack_public_path__ + "img/3a5c0c7.jpg";